import React from "react";
import { X, Edit3, Trash2, User2, Mail, Calendar, Shield } from "lucide-react";
import { Button, Badge } from "../components/AdminSharedComponents";

const UserModal = ({ user, onClose, onEdit, onDelete, formatRoleName, formatDate }) => {
  const handleDeleteClick = () => {
    if (window.confirm(`Apakah Anda yakin ingin menghapus user "${user.name}"?`)) {
      onDelete(user.id);
    }
  };

  // Function to get role badge variant
  const getRoleBadgeVariant = (role) => {
    switch (role) {
      case "superadmin":
        return "danger";
      case "admin_produk":
        return "warning";
      case "admin_proyek":
        return "info";
      case "spv":
        return "success";
      case "client":
        return "secondary";
      default:
        return "primary";
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-semibold text-gray-800">User Details</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* User Avatar */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-gray-200 rounded-full flex items-center justify-center">
              <User2 className="w-10 h-10 text-primary" />
            </div>
          </div>

          {/* User Information */}
          <div className="space-y-4">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-800 mb-2">{user.name}</h3>
              <Badge variant={getRoleBadgeVariant(user.role)}>
                {formatRoleName(user.role)}
              </Badge>
            </div>

            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-gray-400" />
                <div>
                  <p className="text-sm text-gray-500">Email</p>
                  <p className="text-gray-800">{user.email}</p>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <Shield className="w-5 h-5 text-gray-400" />
                <div>
                  <p className="text-sm text-gray-500">Role</p>
                  <p className="text-gray-800">{formatRoleName(user.role)}</p>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <Calendar className="w-5 h-5 text-gray-400" />
                <div>
                  <p className="text-sm text-gray-500">Joined Date</p>
                  <p className="text-gray-800">{formatDate(user.created_at)}</p>
                </div>
              </div>

              {user.updated_at && (
                <div className="flex items-center space-x-3">
                  <Calendar className="w-5 h-5 text-gray-400" />
                  <div>
                    <p className="text-sm text-gray-500">Last Updated</p>
                    <p className="text-gray-800">{formatDate(user.updated_at)}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex justify-end space-x-2 p-6 border-t bg-gray-50">
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => onEdit(user)}
            className="flex items-center"
          >
            <Edit3 size={16} className="mr-2" />
            Edit
          </Button>
          <Button
            variant="danger"
            onClick={handleDeleteClick}
            className="flex items-center"
          >
            <Trash2 size={16} className="mr-2" />
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UserModal;